"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return XcMigrationSource;
    }
});
const _nc_001_init = /*#__PURE__*/ _interop_require_wildcard(require("./v1/nc_001_init"));
const _nc_002_add_m2m = /*#__PURE__*/ _interop_require_wildcard(require("./v1/nc_002_add_m2m"));
const _nc_003_add_fkn_column = /*#__PURE__*/ _interop_require_wildcard(require("./v1/nc_003_add_fkn_column"));
const _nc_004_add_view_type_column = /*#__PURE__*/ _interop_require_wildcard(require("./v1/nc_004_add_view_type_column"));
const _nc_005_add_view_name_column = /*#__PURE__*/ _interop_require_wildcard(require("./v1/nc_005_add_view_name_column"));
const _nc_006_alter_nc_shared_views = /*#__PURE__*/ _interop_require_wildcard(require("./v1/nc_006_alter_nc_shared_views"));
const _nc_007_alter_nc_shared_views_1 = /*#__PURE__*/ _interop_require_wildcard(require("./v1/nc_007_alter_nc_shared_views_1"));
const _nc_008_add_nc_shared_bases = /*#__PURE__*/ _interop_require_wildcard(require("./v1/nc_008_add_nc_shared_bases"));
const _nc_009_add_model_order = /*#__PURE__*/ _interop_require_wildcard(require("./v1/nc_009_add_model_order"));
const _nc_010_add_parent_title_column = /*#__PURE__*/ _interop_require_wildcard(require("./v1/nc_010_add_parent_title_column"));
const _nc_011_remove_old_ses_plugin = /*#__PURE__*/ _interop_require_wildcard(require("./v1/nc_011_remove_old_ses_plugin"));
const _nc_012_cloud_cleanup = /*#__PURE__*/ _interop_require_wildcard(require("./v1/nc_012_cloud_cleanup"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
let XcMigrationSource = class XcMigrationSource {
    // Must return a Promise containing a list of migrations.
    // Migrations can be whatever you want, they will be passed as
    // arguments to getMigrationName and getMigration
    getMigrations() {
        // In this run we are just returning migration names
        return Promise.resolve([
            'project',
            'm2m',
            'fkn',
            'viewType',
            'viewName',
            'nc_006_alter_nc_shared_views',
            'nc_007_alter_nc_shared_views_1',
            'nc_008_add_nc_shared_bases',
            'nc_009_add_model_order',
            'nc_010_add_parent_title_column',
            'nc_011_remove_old_ses_plugin',
            'nc_012_cloud_cleanup'
        ]);
    }
    getMigrationName(migration) {
        return migration;
    }
    getMigration(migration) {
        switch(migration){
            case 'project':
                return _nc_001_init;
            case 'm2m':
                return _nc_002_add_m2m;
            case 'fkn':
                return _nc_003_add_fkn_column;
            case 'viewType':
                return _nc_004_add_view_type_column;
            case 'viewName':
                return _nc_005_add_view_name_column;
            case 'nc_006_alter_nc_shared_views':
                return _nc_006_alter_nc_shared_views;
            case 'nc_007_alter_nc_shared_views_1':
                return _nc_007_alter_nc_shared_views_1;
            case 'nc_008_add_nc_shared_bases':
                return _nc_008_add_nc_shared_bases;
            case 'nc_009_add_model_order':
                return _nc_009_add_model_order;
            case 'nc_010_add_parent_title_column':
                return _nc_010_add_parent_title_column;
            case 'nc_011_remove_old_ses_plugin':
                return _nc_011_remove_old_ses_plugin;
            case 'nc_012_cloud_cleanup':
                return _nc_012_cloud_cleanup;
        }
    }
};
